import { render, staticRenderFns } from "./year.vue?vue&type=template&id=0ae130e8"
import script from "./year.vue?vue&type=script&lang=js"
export * from "./year.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports